import React from 'react';

export const LinearPlotIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            version="1.1"
            viewBox="0 0 5.821 5.821"
        >
            <g fill="#fff" fillOpacity="1">
                <path strokeWidth="0.529" d="M0 2.646H4.762V3.175H0z"></path>
                <path
                    stroke="none"
                    strokeLinecap="butt"
                    strokeLinejoin="miter"
                    strokeOpacity="1"
                    strokeWidth="0.265"
                    d="M4.233 1.852L5.821 2.91 4.233 3.97z"
                ></path>
                <path
                    stroke="none"
                    strokeDasharray="none"
                    strokeMiterlimit="4"
                    strokeOpacity="1"
                    strokeWidth="2"
                    d="M5 2v7h2V4h5v5h2V2H5zm0 11v7h9v-7h-2v5H7v-5H5z"
                    opacity="1"
                    transform="scale(.26458)"
                ></path>
            </g>
        </svg>
    );
};
